import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { EmployeeFilter } from './employee.interface';
import { FilterHelper } from '../helpers/filters';
import { DataCollectorService } from '../data_collector_services/data_collector_service.service';

@Injectable({
  providedIn: 'root'
})

export class EmployeeService {

  get employeeApiUrls(): any{
    return {
      dataUrl : `${this.datacollectorservice.baseurl()}/users/filter`,
      columnUrl: `${this.datacollectorservice.baseurl()}/users/meta`,
      filterUrl: `${this.datacollectorservice.baseurl()}/users/meta/filter`,
      teamsDataUrl: `${this.datacollectorservice.baseurl()}/teams/summary`,
      userListUrl: `${this.datacollectorservice.baseurl()}/user/all`,
      teamPOSTUrl: `${this.datacollectorservice.baseurl()}/team`,
      usersPostUrl: `${this.datacollectorservice.baseurl()}/user`
    };
  }

  get employeeDetailsUrls(): any{
    return {
      locationsUrl: `${this.datacollectorservice.baseurl()}/users/location`
    };
  }
  employeeDetailsLoaded =new Subject<boolean>();


  constructor(private http: HttpClient, private filterHelper: FilterHelper,private datacollectorservice:DataCollectorService) {
    this.employeeDetailsLoaded.next(false);
  }

  changePwdUrl(params): string{
    return `${this.datacollectorservice.baseurl()}/user/${params.userId}/password?password=${params.password}&remove_all_session=${params.removeSession}`;
  }

  activationURl(userId: string): string{
    return `${this.datacollectorservice.baseurl()}/user/${userId}/activation`;
  }

  getUserURL(userId: string): string {
    return `${this.datacollectorservice.baseurl()}/user/` + userId;
  }

  getDeleteURL(userId: string): string {
    return `${this.datacollectorservice.baseurl()}/user/${userId}/delete`;
  }

  getSkillsURL(userId: string): string {
    return `${this.datacollectorservice.baseurl()}/users/` + userId + '/skill';
  }

  getTeamsURL(userId: string): string {
    return `${this.datacollectorservice.baseurl()}/user/` + userId + '/teams';
  }

  getWorkHoursURL(userId: string): string {
    return `${this.datacollectorservice.baseurl()}/user/` + userId + '/work_hours';
  }

  getAllUsers(page = 1, limit = 10): any{
    const userURL = `${this.datacollectorservice.baseurl()}/user/all?limit=${limit}&page=${page}`;
    return this.datacollectorservice.getData(userURL);
  }

  public getUsers(page = 1, limit = 10, filter: EmployeeFilter): Observable<any> {

    let params = new HttpParams();

    params = params.set('limit', limit);
    params = params.set('page', page);

    if (filter.keyword && filter.keyword.length > 0) {
      params = params.set('filter.keyword', filter.keyword);
    }
    if (filter.roleID && filter.roleID !== '0') {
      params = params.set('filter.role_id', filter.roleID);
    }
    if (filter.teamUID && filter.teamUID !== '0') {
      params = params.set('filter.team_uid', filter.teamUID);
    }
    if (filter.skillsetUID && filter.skillsetUID.length > 0) {
      params = params.set('filter.skillset_uid', filter.skillsetUID.toString());
    }
    if (filter.isActive && filter.isActive !== '0') {
      params = params.set('filter.is_active', filter.isActive);
    }
    if (filter.customField.label && filter.customField.label !== '0') {
      const fitlerString = this.filterHelper.customFieldFilterParams(filter.customField);
      params = params.set('filter.custom_field', fitlerString);
    }

    const userURL = `${this.datacollectorservice.baseurl()}/user/all`;

    return this.datacollectorservice.getData(userURL, params);
  }

  public getTeams(): Observable<any> {

    const teamURL = 'team'

    return this.http.get(teamURL);
  }

  public getTeamsSummary(page = 1, limit = 10, filter): Observable<any> {

    let params = new HttpParams();

    params = params.set('limit', limit);
    params = params.set('page', page);

    if (filter && filter.date) {
      params = params.set("filter.date", filter.date);
    }
    if (filter && filter.keyword) {
      params = params.set("filter.keyword", filter.keyword);
    }
    if (filter && filter.isActive) {
      params = params.set("filter.is_active", filter.isActive);
    }
    if (filter && filter.roleID) {
      params = params.set("filter.role_id", filter.roleID);
    }
    if (filter && filter.teamUID) {
      params = params.set("filter.team_uid", filter.teamUID);
    }
    if (filter && filter.userUID) {
      params = params.set("filter.user_uid", filter.userUID);
    }
    if (filter && filter.custom_field && filter.customField.label !== '0') {
      const fitlerString = this.filterHelper.customFieldFilterParams(filter.customField);
      params = params.set('filter.custom_field', fitlerString);
    }
    if (filter && filter.skillsetUID) {
      params = params.set("filter.skillset_uid", filter.skillsetUID);
    }
    if (filter && filter.populateSkills) {
      params = params.set("populate_skills", filter.populateSkills);

    }

    const teamSummaryURL = 'teams/summary'

    return this.http.get(teamSummaryURL, { params: params });

  }

  public createTeam(team, user_uid): Observable<any> {

    let params = new HttpParams();

    if (user_uid) {
      params = params.set('user_uid', user_uid);
    }

    const teamURL = 'team'

    return this.http.post(teamURL, team, { params: params })

  }

  public getTeamUsers(teamUID): Observable<any> {

    const teamURL = 'team/' + teamUID;

    return this.http.get(teamURL);

  }

  public updateTeam(teamUID, team): Observable<any> {

    const teamURL = 'team/' + teamUID;

    return this.http.put(teamURL, team);

  }

  public deleteTeam(teamUID, reassignTo): Observable<any> {

    let params = new HttpParams();

    params = params.set('reassign_to', reassignTo);

    const teamURL = 'team/' + teamUID;

    return this.http.delete(teamURL, { params: params });

  }

  public createEmployee(employee): Observable<any> {

    const employeeURL = 'user';

    return this.http.post(employeeURL, employee);

  }

  public assignUserToTeam(teamUID, userUID): Observable<any> {

    let params = new HttpParams();
    params = params.set('user_uid', userUID);
    params = params.set('team_uid', teamUID);

    const teamAssingURL = 'team/assign';

    return this.http.post(teamAssingURL, { params: params });

  }

  public unassignUser(teamUID, userUID): Observable<any> {

    let params = new HttpParams();
    params = params.set('user_uid', userUID);
    params = params.set('team_uid', teamUID);

    const teamUnassingURL = 'team/unassign';

    return this.http.post(teamUnassingURL, { params: params });

  }

  public getEmployeeDetails(userUID): Observable<any> {

    const employeeURL = 'user/' + userUID

    return this.http.get(employeeURL);

  }

  public getWorkHours(userUID): Observable<any> {

    const workHoursURL = 'user/' + userUID + 'work_hours'

    return this.http.get(workHoursURL);

  }

  public updateWorkHours(userUID, workHours): Observable<any> {

    const workHoursURL = 'user/' + userUID + 'work_hours';

    return this.http.put(workHoursURL, workHours);

  }

  public updateUser(userUID, user): Observable<any> {

    const userUrl = 'user/' + userUID + '/update';

    return this.http.put(userUrl, user);

  }

  public deactivateUser(userUID, type): Observable<any> {

    const userDeactivateUrl = 'user/' + userUID + '/activation';

    return this.http.put(userDeactivateUrl, type);

  }

  public changePassword(userUID, password, removeAllSession): Observable<any> {

    let params = new HttpParams();
    params = params.set('password', password);
    params = params.set('remove_all_session', removeAllSession);

    const passwordChangeUrl = 'user/' + userUID + '/password';

    return this.http.post(passwordChangeUrl, { params: params });

  }


  public deleteUser(userUID): Observable<any> {

    const userUrl = 'user/' + userUID + '/delete';

    return this.http.delete(userUrl);

  }

  public getEmployeeTeams(userUID): Observable<any> {

    const userTeamsUrl = 'user/' + userUID + '/teams';

    return this.http.get(userTeamsUrl);

  }

  public getResources(userUID, filter): Observable<any> {

    let params = new HttpParams();

    if (filter && filter.userUID) {
      params = params.set("filter.user_uid", filter.userUID);
    }

    const userResourcesUrl = 'users/' + userUID + '/resources';

    return this.http.get(userResourcesUrl, { params: params });

  }

  public addNewResource(resource): Observable<any> {

    const userResourcesUrl = 'users/' + resource.userUID + '/resources';

    return this.http.post(userResourcesUrl, resource);

  }

  public deleteResource(resourceUID, userUID): Observable<any> {

    const userResourcesUrl = 'users/' + userUID + '/resources' + resourceUID;

    return this.http.delete(userResourcesUrl);

  }

  public getLocations(userUID): Observable<any> {

    let params = new HttpParams();

    if (userUID) {
      params = params.set("filter.user_uid", userUID);
    }

    const userLocationsUrl = 'users/locations';

    return this.http.get(userLocationsUrl, { params: params });

  }

  public assignLocation(location): Observable<any> {

    const userLocationsUrl = 'users/locations';

    return this.http.post(userLocationsUrl, location);

  }

  public unassignLocation(locationUID): Observable<any> {

    const userLocationsUrl = 'users/locations' + locationUID;

    return this.http.delete(userLocationsUrl);

  }

  public getSkills(userUID): Observable<any> {

    const userSkillsUrl = 'users/' + userUID + '/skill';

    return this.http.get(userSkillsUrl);

  }

  public assignSkill(skill, userUID): Observable<any> {

    const userSkillsUrl = 'users/' + userUID + '/skill';

    return this.http.post(userSkillsUrl, skill);

  }

  public updateSkill( skill, userUID, userSkillUID): Observable<any> {

    const userSkillsUrl = 'users/' + userUID + '/skill' + userSkillUID;

    return this.http.put(userSkillsUrl, skill);

  }

  public deleteSkill(userUID, userSkillUID): Observable<any> {

    const userSkillsUrl = 'users/' + userUID + '/skill' + userSkillUID;

    return this.http.delete(userSkillsUrl);

  }

  public getModules(): Observable<any> {

    const modulesUrl = 'company/modules';

    return this.http.get(modulesUrl)
  
  }

  public createUserModule(userUID, modules): Observable<any> {

    const modulesUrl = 'user/' + userUID + 'modules'

    return this.http.post(modulesUrl, modules)

  }

}
